/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import classes from "./reports.module.css";
import Select from "@mui/material/Select";
import BusApiCall from "../../../helper/axios";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Loader from "../../../component/loader";
import Breadcrumb from "../../../component/breadcrumb";
import { Paper, TableFooter } from "@mui/material";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { MenuItem } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Input from "../../../component/inputpm";
import { Tooltip, IconButton } from "@mui/material";
import {
  SearchIcon,
  ClearIcon,
  DownloadIconNew,
} from "../../../component/icons/icons";
import { TextField } from "@mui/material";
import moment from "moment";
import { Grid } from "@mui/material";
import { CSVLink } from "react-csv";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AppBar from "@mui/material/AppBar";
import TabPanel from "../../../component/tabPanel";
import orderClasses from "../orders/orders.module.css";
import Button from "../../../component/button";
import BanSelect from "../checkout/customerDetails/banSelect";
import reportClasses from "../reports/reports.module.css";
import { withNavigation } from "../../../helper/withNavigation";
import { formatNumber } from "../../../helper/numberFormatter";

class GenericReports extends Component {
  // Declare property values that belongs to the component
  state = {
    reportData: [],
    reportName: "",
    reportTitle: "",
    orderBy: "",
    totalCount: 0,
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    bread: [],
    inputParameters: [],
    showPagination: false,
    nestedReport: false,
    nestedReportData: [],
    searchParameters: [],
    today: moment(new Date()).format("yyyy-MM-DD"),
    todayTime: moment(new Date()).format("yyyy-MM-DDThh:mm"),
    csvData: ``,
    tabValue: 0,
    monthList: [
      {
        name: "Jan",
        value: 0,
      },
      {
        name: "Feb",
        value: 1,
      },
      {
        name: "Mar",
        value: 2,
      },
      {
        name: "Apr",
        value: 3,
      },
      {
        name: "May",
        value: 4,
      },
      {
        name: "June",
        value: 5,
      },
      {
        name: "July",
        value: 6,
      },
      {
        name: "Aug",
        value: 7,
      },
      {
        name: "Sep",
        value: 8,
      },
      {
        name: "Oct",
        value: 9,
      },
      {
        name: "Nov",
        value: 10,
      },
      {
        name: "Dec",
        value: 11,
      },
    ],
    yearsList: [],
    selectedYear: new Date().getFullYear(),
    selectedMonth: new Date().getMonth(),
    excelData: ``,
    customersList: [],
    defaultSelected: {
      label: "All Customers",
      value: "_ALL_CUSTS__",
      ban: "_ALL_CUSTS__",
    },

    selectedCustomer: "_ALL_CUSTS__",
    selectedCustomerName: "",
    isDownloadShippingReport: false,
    downloadReady: false,
    startDate: "",
    endDate: "",
    searchedCsvData: ``,
    searchedExcelData: ``,
    customFilters: [],
    customSearchParameters: [],
    isDownloadableReport: false,
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.router.params.reportName !== this.props.router.params.reportName
    ) {
      this.setState({
        tabValue: 0,
        inputParameters: [],
        customFilters: [],
        totalCount: 0,
        reportData: [],
      });
      var tempReportName = {
        reportId: nextProps.router.params.reportName,
      };
      this.setState({ loading: true });
      BusApiCall(
        "GET",
        `${constants.genericReportUrl}?reportName=${"getAvailableReports"}&reportParameters=${btoa(JSON.stringify(tempReportName))}`,
      )
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.reportDataJson &&
            res.data.reportDataJson.reportData &&
            res.data.reportDataJson.reportData.length > 0
          ) {
            let inputParameters =
              res.data.reportDataJson.reportData[0].inputParameters &&
              res.data.reportDataJson.reportData[0].inputParameters.length > 0
                ? res.data.reportDataJson.reportData[0].inputParameters
                : [];
            let reportTitle = nextProps.router.location.state.reportDescription;
            let customFilters =
              res.data.reportDataJson.reportData[0].customFilter &&
              res.data.reportDataJson.reportData[0].customFilter.length > 0
                ? res.data.reportDataJson.reportData[0].customFilter
                : [];
            this.setState(
              {
                reportName: nextProps.router.params.reportName,
                totalCount: 0,
                orderBy: "",
                startRecord: 1,
                rowsPerPage: 10,
                page: 1,
                reportData: [],
                inputParameters: inputParameters ? inputParameters : [],
                reportTitle,
                nestedReport: false,
                nestedReportData: [],
                showPagination: false,
                searchParameters: [],
                customFilters: customFilters ? customFilters : [],
              },
              () => {
                if (this.props.screen && this.props.screen === "dashboard") {
                } else {
                  this.setState({
                    bread: [
                      { title: "Reports", url: nextProps.router.location.pathname },
                      {
                        title: this.state.reportTitle,
                        url: nextProps.router.location.pathname,
                      },
                    ],
                  });
                }
                this.getFullReport("onload");
                // this.downloadGenericReport('onload');
              },
            );
          } else {
            let inputParameters = nextProps.router.location.state.inputParameters;
            let reportTitle = nextProps.router.location.state.reportDescription;
            let customFilters = nextProps.router.location.state.customFilter;
            this.setState(
              {
                reportName: nextProps.router.params.reportName,
                totalCount: 0,
                orderBy: "",
                startRecord: 1,
                rowsPerPage: 10,
                page: 1,
                reportData: [],
                inputParameters: inputParameters ? inputParameters : [],
                reportTitle,
                nestedReport: false,
                nestedReportData: [],
                showPagination: false,
                searchParameters: [],
                customFilters: customFilters ? customFilters : [],
              },
              () => {
                if (this.props.screen && this.props.screen === "dashboard") {
                } else {
                  this.setState({
                    bread: [
                      { title: "Reports", url: nextProps.router.location.pathname },
                      {
                        title: this.state.reportTitle,
                        url: nextProps.router.location.pathname,
                      },
                    ],
                  });
                }
                this.getFullReport("onload");
                // this.downloadGenericReport('onload');
              },
            );
          }
          if (
            this.state.customFilters.length > 0 &&
            this.state.customFilters[0].downloadable
          ) {
            this.setState({
              isDownloadableReport: true,
            });
            this.downloadGenericReport("onload");
          } else {
            if (
              this.state.reportName === "getItemsShippedToCustomer" ||
              this.state.reportName === "getInventoryReceiptReport"
            ) {
              // this.setState({
              //     isDownloadableReport: true
              // })
              this.downloadGenericReport("onload");
            }
          }
        })
        .catch((err) => {
          let inputParameters = nextProps.router.location.state.inputParameters;
          let reportTitle = nextProps.router.location.state.reportDescription;
          let customFilters = nextProps.router.location.state.customFilter;
          this.setState(
            {
              reportName: nextProps.router.params.reportName,
              totalCount: 0,
              orderBy: "",
              startRecord: 1,
              rowsPerPage: 10,
              page: 1,
              reportData: [],
              inputParameters: inputParameters ? inputParameters : [],
              reportTitle,
              nestedReport: false,
              nestedReportData: [],
              showPagination: false,
              searchParameters: [],
              customFilters: customFilters ? customFilters : [],
            },
            () => {
              if (this.props.screen && this.props.screen === "dashboard") {
              } else {
                this.setState({
                  bread: [
                    { title: "Reports", url: nextProps.router.location.pathname },
                    {
                      title: this.state.reportTitle,
                      url: nextProps.router.location.pathname,
                    },
                  ],
                });
              }
              this.getFullReport("onload");
              // this.downloadGenericReport('onload');
              if (
                this.state.customFilters.length > 0 &&
                this.state.customFilters[0].downloadable
              ) {
                this.setState({
                  isDownloadableReport: true,
                });
                this.downloadGenericReport("onload");
              } else {
                if (
                  this.state.reportName === "getItemsShippedToCustomer" ||
                  this.state.reportName === "getInventoryReceiptReport"
                ) {
                  // this.setState({
                  //     isDownloadableReport: true
                  // })
                  this.downloadGenericReport("onload");
                }
              }
            },
          );
        });
    }
  }

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.setState({
      tabValue: 0,
    });
    this.yearsList();
    let inputParameters = this.props.router.location.state.inputParameters;
    let reportTitle = this.props.router.location.state.reportDescription;
    let customFilters = this.props.router.location.state.customFilter;
    this.props.setCompDidMount();
    this.getCustomers();

    var tempReportName = {
      reportId: this.props.router.params.reportName,
    };
    this.setState({ loading: true });
    BusApiCall(
      "GET",
      `${constants.genericReportUrl}?reportName=${"getAvailableReports"}&reportParameters=${btoa(JSON.stringify(tempReportName))}`,
    )
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.reportDataJson &&
          res.data.reportDataJson.reportData &&
          res.data.reportDataJson.reportData.length > 0
        ) {
          this.setState(
            {
              reportName: this.props.router.params.reportName,
              inputParameters: res.data.reportDataJson.reportData[0]
                .inputParameters
                ? res.data.reportDataJson.reportData[0].inputParameters
                : [],
              reportTitle,
              customFilters: res.data.reportDataJson.reportData[0].customFilter
                ? res.data.reportDataJson.reportData[0].customFilter
                : [],
            },
            () => {
              if (this.props.screen && this.props.screen === "dashboard") {
              } else {
                this.setState({
                  bread: [
                    {
                      title: "Report",
                      url: this.props.router.location.pathname,
                    },
                    {
                      title: this.state.reportTitle,
                      url: this.props.router.location.pathname,
                    },
                  ],
                });
              }
              this.getFullReport("onload");
            },
          );
        } else {
          this.setState(
            {
              reportName: this.props.router.params.reportName,
              inputParameters: inputParameters ? inputParameters : [],
              reportTitle,
              customFilters: customFilters ? customFilters : [],
            },
            () => {
              if (this.props.screen && this.props.screen === "dashboard") {
              } else {
                this.setState({
                  bread: [
                    {
                      title: "Report",
                      url: this.props.router.location.pathname,
                    },
                    {
                      title: this.state.reportTitle,
                      url: this.props.router.location.pathname,
                    },
                  ],
                });
              }
              this.getFullReport("onload");
            },
          );
        }
        if (
          this.state.customFilters.length > 0 &&
          this.state.customFilters[0].downloadable
        ) {
          this.setState({
            isDownloadableReport: true,
          });
          this.downloadGenericReport("onload");
        } else {
          if (
            this.state.reportName === "getItemsShippedToCustomer" ||
            this.state.reportName === "getInventoryReceiptReport"
          ) {
            // this.setState({
            //     isDownloadableReport: true
            // })
            this.downloadGenericReport("onload");
          }
        }
      })
      .catch((err) => {
        this.setState(
          {
            reportName: this.props.router.params.reportName,
            inputParameters: inputParameters ? inputParameters : [],
            reportTitle,
            customFilters: customFilters ? customFilters : [],
          },
          () => {
            this.setState({
              bread: [
                { title: "Report", url: this.props.router.location.pathname },
                {
                  title: this.state.reportTitle,
                  url: this.props.router.location.pathname,
                },
              ],
            });
            this.getFullReport("onload");
            if (
              this.state.customFilters.length > 0 &&
              this.state.customFilters[0].downloadable
            ) {
              this.setState({
                isDownloadableReport: true,
              });
              this.downloadGenericReport("onload");
            } else {
              if (
                this.state.reportName === "getItemsShippedToCustomer" ||
                this.state.reportName === "getInventoryReceiptReport"
              ) {
                // this.setState({
                //     isDownloadableReport: true
                // })
                this.downloadGenericReport("onload");
              }
            }
          },
        );
      });
  }

  getCustomers = () => {
    let partyId = "";
    if (
      this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
      this.props.loggedInUserType === "ECOMMERCE_ADMIN"
    ) {
      partyId = this.props.ecommerceCustData.partyId;
    } else {
      partyId = this.props.providerId;
    }
    BusApiCall(
      "GET",
      `${constants.busV4Url}/parties/${partyId}/hierarchy?level=${1}`,
    )
      .then((res) => {
        let list = res.data.customers.map((a) => {
          return {
            ...a,
            label: `BAN #${a.ban} - ${a.accountName}`,
            value: a.ban,
          };
        });
        let allCustomers = {
          label: this.props.t("ALL_CUSTOMERS"),
          value: "_ALL_CUSTS__",
          ban: "_ALL_CUSTS__",
        };
        let finalList = [allCustomers].concat(list);
        this.setState({
          customersList: finalList,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false, totalCount: 0 });
      });
  };

  onBanSelect = (e) => {
    this.setState({
      downloadReady: false,
      selectedCustomer: e.ban,
      defaultSelected: e,
    });
  };

  yearsList = () => {
    var currentYear = new Date().getFullYear(),
      years = [];
    let startYear = 2020;
    while (startYear <= currentYear) {
      years.push(startYear++);
    }
    this.setState({
      yearsList: years,
    });
  };
  getLastDay = (y, m) => {
    return new Date(y, m + 1, 0).getDate();
  };
  getFullReport = (event) => {
    this.setState({ loading: true });
    let showPagination = this.state.showPagination;
    let search = {};
    var ecommerceCustomerInfo = JSON.parse(
      localStorage.getItem("ecommerceCustData"),
    );
    var pIndex = this.state.inputParameters.findIndex(
      (p) => p.name === "x-start-record",
    );
    if (pIndex > -1) {
      showPagination = true;
    } else {
      showPagination = false;
    }
    this.setState({
      showPagination,
    });
    if (event === "onload") {
      let searchParameters = [];
      let customSearchParameters = [];
      for (let i = 0; i < this.state.inputParameters.length; i++) {
        // if (this.state.inputParameters[i].name === 'x-start-record') {
        //     showPagination = true;
        // } else {
        //     showPagination = false;
        // }
        if (
          this.state.inputParameters[i].name !== "x-start-record" &&
          this.state.inputParameters[i].name !== "x-batch-size" &&
          this.state.inputParameters[i].name !== "sortBy" &&
          this.state.inputParameters[i].name !== "sortOrder" &&
          this.state.inputParameters[i].name !== "customFilterData"
        ) {
          if (this.state.inputParameters[i].name === "customerName") {
            if (
              this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
              this.props.loggedInUserType === "ECOMMERCE_ADMIN"
            ) {
              this.state.inputParameters[i].value =
                ecommerceCustomerInfo.accountName;
            } else {
              this.state.inputParameters[i].value = "";
            }
          } else {
            this.state.inputParameters[i].value = "";
          }
          searchParameters.push(this.state.inputParameters[i]);
        }
      }
      var customSearchFilters = {};
      for (let i = 0; i < this.state.customFilters.length; i++) {
        var opt = this.state.customFilters[i];
        if (opt.type === "List") {
          if (opt.options && opt.options.length > 0) {
            opt.options.sort((a, b) => a.name.localeCompare(b.name));
            opt.value = opt.options[0].id;
          } else {
            opt.value = "";
            opt.options = [];
          }
        } else {
          opt.value = "";
        }
        customSearchParameters.push(opt);
        customSearchFilters[opt.name] = opt.value;
      }
      this.setState({
        // showPagination,
        searchParameters,
        customSearchParameters,
      });
      for (let i = 0; i < searchParameters.length; i++) {
        search[searchParameters[i].name] = searchParameters[i].value;
      }
      if (customSearchParameters && customSearchParameters.length > 0) {
        search["customFilterData"] = JSON.stringify(customSearchFilters);
      }
    } else {
      for (let i = 0; i < this.state.searchParameters.length; i++) {
        if (this.state.searchParameters[i].name === "customerName") {
          if (
            this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
            this.props.loggedInUserType === "ECOMMERCE_ADMIN"
          ) {
            search[this.state.searchParameters[i].name] =
              ecommerceCustomerInfo.accountName;
          } else {
            search[this.state.searchParameters[i].name] = this.state
              .searchParameters[i].formatedValue
              ? this.state.searchParameters[i].formatedValue
              : this.state.searchParameters[i].value;
          }
        } else {
          search[this.state.searchParameters[i].name] = this.state
            .searchParameters[i].formatedValue
            ? this.state.searchParameters[i].formatedValue
            : this.state.searchParameters[i].value;
        }
      }
      var customSearchFilters = {};
      for (let i = 0; i < this.state.customSearchParameters.length; i++) {
        search[this.state.customSearchParameters[i].name] = this.state
          .customSearchParameters[i].formatedValue
          ? this.state.customSearchParameters[i].formatedValue
          : this.state.customSearchParameters[i].value;
        customSearchFilters[this.state.customSearchParameters[i].name] = this
          .state.customSearchParameters[i].formatedValue
          ? this.state.customSearchParameters[i].formatedValue
          : this.state.customSearchParameters[i].value;
      }
      if (
        this.state.customSearchParameters &&
        this.state.customSearchParameters.length > 0
      ) {
        search["customFilterData"] = JSON.stringify(customSearchFilters);
      }
    }
    if (this.state.tabValue === 1) {
      delete search.startDate;
      delete search.endDate;

      var startDate = moment();
      var endDate = moment();

      startDate.set("year", this.state.selectedYear);
      endDate.set("year", this.state.selectedYear);

      startDate.set("month", this.state.selectedMonth);
      endDate.set("month", this.state.selectedMonth);

      startDate.set("date", 1);
      endDate.set(
        "date",
        this.getLastDay(this.state.selectedYear, this.state.selectedMonth),
      );

      search.startDate = startDate.format("MM/DD/yyyy Z");
      search.endDate = endDate.format("MM/DD/yyyy Z");
    }
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    let url;
    if (showPagination) {
      url = BusApiCall(
        "GET",
        `${constants.genericReportUrl}?reportName=${this.state.reportName}&reportParameters=${btoa(JSON.stringify(search))}`,
        {},
        pageOptions,
      );
    } else {
      url = BusApiCall(
        "GET",
        `${constants.genericReportUrl}?reportName=${this.state.reportName}&reportParameters=${btoa(JSON.stringify(search))}`,
      );
    }
    let nestedReport = false;
    let nestedReportData = [];
    url
      .then((res) => {
        let fullReportData = res.data;
        if (fullReportData.reportDataJson.reportData.length > 0) {
          let nestedCheckObj = fullReportData.reportDataJson.reportData[0];
          for (var key in nestedCheckObj) {
            if (Array.isArray(nestedCheckObj[key])) {
              nestedReport = true;
              let allReportsList = fullReportData.reportDataJson.reportData;
              for (var i = 0; i < allReportsList.length; i++) {
                for (var report in allReportsList[i]) {
                  if (Array.isArray(allReportsList[i][report])) {
                    nestedReportData.push(allReportsList[i][report]);
                  }
                }
              }
            }
          }
        }

        this.setState(
          {
            nestedReport,
            totalCount: fullReportData["x-total-count"],
            orderBy: fullReportData["x-order-by"],
            startRecord: fullReportData["x-result-start"],
          },
          () => {
            this.setState(
              {
                reportData: fullReportData.reportDataJson.reportData,
                nestedReportData: nestedReportData,
                loading: false,
              },
              () => {
                console.log("check props", this.props, window);
                if (this.props.screen && this.props.screen === "dashboard") {
                  if (this.props.scrollPosition) {
                    var scrollPosition = this.props.scrollPosition;
                    window.scrollTo(0, scrollPosition);
                  }
                }
              },
            );
          },
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
        this.setState({ loading: false });
      });
  };

  camelCasetoSentenceString = (val) => {
    const result = val.replace(/([A-Z])/g, " $1");
    var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    if (finalResult.includes("Rma")) {
      finalResult = finalResult.replace("Rma", "RMA");
    }
    if (finalResult.includes("Po")) {
      finalResult = finalResult.replace("Po", "PO");
    }
    if (finalResult.includes("Ban")) {
      finalResult = finalResult.replace("Ban", "BAN");
    }
    return finalResult;
  };

  validateAndConvertTimeStamp = (val) => {
    let valid = new Date(val).getTime() > 0;
    if (valid) {
      let date = new Date(val);
      let month = date.getUTCMonth() + 1;
      var day = date.getUTCDate();
      var year = date.getUTCFullYear();
      var hour = date.getHours();
      var minutes = date.getMinutes();
      return month + "/" + day + "/" + year + " " + hour + ":" + minutes;
    } else {
      return val;
    }
  };

  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
        rowsPerPage: event.target.value,
      },
      () => {
        this.getFullReport();
      },
    );
  };

  changePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getFullReport();
      },
    );
  };

  getNestedReportFooter = (index) => {
    let allReportsList = [...this.state.reportData];
    let selectedReport = allReportsList[index];
    let data = [];
    for (var report in selectedReport) {
      if (!Array.isArray(selectedReport[report])) {
        let obj = {
          title: report,
          value: selectedReport[report],
        };
        data.push(obj);
      }
    }
    return Object.keys(data).length === 0 ? "" : data;
  };

  downloadReport = () => {
    let tempData = [...this.state.reportData];
    var encoded = btoa(JSON.stringify(tempData));
    // Convert pdf to array buffer
    var arrrayBuffer = this.base64ToArrayBuffer(encoded);
    // Create pdf blob
    var blob = new Blob(
      [arrrayBuffer],
      { type: "application/pdf" },
      this.state.reportTitle + " report.pdf",
    );
    // Create URL object and download
    var url = window.URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.download = this.state.reportTitle + " report.pdf";
    link.dispatchEvent(new MouseEvent("click"));
  };

  // Covert base64 to array buffer
  base64ToArrayBuffer = (base64) => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };
  // Change search filters data
  onChange = (e) => {
    let tempSearchParameters = [...this.state.searchParameters];
    for (var i = 0; i < tempSearchParameters.length; i++) {
      if (tempSearchParameters[i].name === e.target.name) {
        tempSearchParameters[i].value = e.target.value;
        if (e.target.type === "datetime-local") {
          tempSearchParameters[i].formatedValue = moment(e.target.value).format(
            "MM/DD/yyyy H:m:s X",
          );
        } else if (e.target.type === "date") {
          tempSearchParameters[i].formatedValue = moment(e.target.value).format(
            "MM/DD/yyyy Z",
          );
        }
        break;
      }
    }
    this.setState({
      searchParameters: tempSearchParameters,
    });
  };
  onChangeCustomFilters = (e) => {
    let tempSearchParameters = [...this.state.customSearchParameters];
    for (var i = 0; i < tempSearchParameters.length; i++) {
      if (tempSearchParameters[i].name === e.target.name) {
        tempSearchParameters[i].value = e.target.value;
        if (e.target.type === "datetime-local") {
          tempSearchParameters[i].formatedValue = moment(e.target.value).format(
            "MM/DD/yyyy H:m:s X",
          );
        } else if (e.target.type === "date") {
          tempSearchParameters[i].formatedValue = moment(e.target.value).format(
            "MM/DD/yyyy Z",
          );
        }
        break;
      }
    }
    this.setState({
      customSearchParameters: tempSearchParameters,
    });
  };

  // On press enter inside search input fields
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterReportTable();
    }
  };
  onChangeMonthFilter = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  // On press search icon
  filterReportTable = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getFullReport();
        this.downloadGenericReport();
      },
    );
  };
  // On press clear search filters icon
  clearReportTableSearch = () => {
    let tempSearchParameters = [...this.state.searchParameters];
    for (var i = 0; i < tempSearchParameters.length; i++) {
      tempSearchParameters[i].value = "";
      if (tempSearchParameters[i].formatedValue) {
        tempSearchParameters[i].formatedValue = "";
      }
    }
    this.setState(
      {
        page: 1,
        startRecord: 1,
        searchParameters: tempSearchParameters,
        selectedYear: new Date().getFullYear(),
        selectedMonth: new Date().getMonth(),
      },
      () => {
        this.getFullReport();
        this.downloadGenericReport();
      },
    );
  };
  // Set input type dynamically
  getInputType = (type) => {
    switch (type) {
      case "String":
        return "text";
      case "Integer":
        return "number";
      default:
        return "text";
    }
  };

  // Check if input label have date in it then it's a date input
  isDateInput = (type) => {
    let val = type.split(" ");
    for (var i = 0; i < val.length; i++) {
      if (val[i].toLowerCase() === "date") {
        return true;
      }
    }
    return false;
  };

  downloadGenericReport = (event) => {
    this.setState({
      loading: true,
    });
    // let payload = {
    //     fromPartyId: this.state.selectedSalesChannel.id,
    //     toPartyId: this.state.selectedItem.id
    // };

    let search = {};
    for (let i = 0; i < this.state.searchParameters.length; i++) {
      search[this.state.searchParameters[i].name] = this.state.searchParameters[
        i
      ].formatedValue
        ? this.state.searchParameters[i].formatedValue
        : this.state.searchParameters[i].value;
    }
    for (let i = 0; i < this.state.customSearchParameters.length; i++) {
      search[this.state.customSearchParameters[i].name] = this.state
        .customSearchParameters[i].formatedValue
        ? this.state.customSearchParameters[i].formatedValue
        : this.state.customSearchParameters[i].value;
    }
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    this.setState({ loading: true });

    let action = "";
    if (this.state.reportName === "getInventoryReceiptReport") {
      action = "GET_INVENTORY_RECEIVED";
    }
    if (this.state.reportName === "getItemsShippedToCustomer") {
      action = "GET_SHIPPED_ITEMS";
    }
    if (this.state.reportName === "getAccountPayable") {
      action = "GET_PARTNER_PAYABLE";
    }
    if (this.state.reportName === "getAccountReceivable") {
      action = "GET_RECEIVABLE_PAYMENT";
    }
    if (this.state.reportName === "getUnpaidOrders") {
      action = "GET_UNPAID_ORDERS";
    }
    if (action && action !== "") {
      BusApiCall(
        "POST",
        `${constants.busInternalUrl}/passthru/${action}/endpoint`,
        search,
      )
        .then((res) => {
          let data = decodeURIComponent(res.data.csvData);
          let excelData = decodeURIComponent(res.data.excelData);
          this.setState({
            csvData: data,
            excelData: excelData,
            loading: false,
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
          });
        });
    }
  };
  changeTab = (e, newValue) => {
    this.clearReportTableSearch();
    this.setState({
      nestedReport: false,
      nestedReportData: [],
      reportData: [],
      totalCount: 0,
      tabValue: newValue,
    });
  };

  downloadShippingReport = () => {
    this.downExcelReport(this.state.excelData);
  };

  downExcelReport = (data) => {
    const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data}`;
    const downloadLink = document.createElement("a");
    const fileName = this.state.reportTitle + ` report.xls`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  createDownloadFile = () => {
    this.setState({
      loading: true,
    });
    var payload = {
      startDate: moment(this.state.startDate).format("MM/DD/yyyy H:m:s X"),
      endDate: moment(this.state.endDate).format("MM/DD/yyyy H:m:s X"),
    };
    var index = this.state.customersList.findIndex(
      (x) => x.ban === this.state.selectedCustomer,
    );
    if (index > -1) {
      payload.customerName = this.state.customersList[index].accountName
        ? this.state.customersList[index].accountName
        : "";
    } else {
      // payload.customerName = 'All Customers';
      payload.customerName = "";
    }
    let action = "GET_SHIPPED_ITEMS";

    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/${action}/endpoint`,
      payload,
    )
      .then((res) => {
        let data = decodeURIComponent(res.data.csvData);
        let excelData = decodeURIComponent(res.data.excelData);
        this.setState({
          searchedCsvData: data,
          searchedExcelData: excelData,
          downloadReady: true,
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  onChangeDateFilter = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      downloadReady: false,
    });
  };

  onSearchDateFilterKeyDown = (e) => {
    if (e.key === "Enter") {
      this.createDownloadFile();
    }
  };
  // Render catalog view
  render() {
    const { t } = this.props;

    return (
      <div
        className={"newContentWrapper"}
        style={{
          marginTop:
            this.props.screen && this.props.screen === "dashboard"
              ? "0px"
              : "56px",
        }}
      >
        {this.props.screen && this.props.screen === "dashboard" ? null : (
          <div className={"breadcrumbWrapper"}>
            <div className={"breadcrumbContent"}>
              <Grid container>
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <Breadcrumb list={this.state.bread} />
                </Grid>
              </Grid>
            </div>
          </div>
        )}
        <main
          style={
            this.props.screen && this.props.screen === "dashboard"
              ? {
                  background: "transparent",
                  paddingLeft: 0,
                  paddingRight: 0,
                  minHeight: "auto",
                }
              : {}
          }
        >
          {/* <Button onClick={() => this.downloadReport()}>Download Report</Button> */}
          {this.state.reportName === "getOpenReturnDetail" && (
            <AppBar position="static" color="transparent">
              <Tabs value={this.state.tabValue} onChange={this.changeTab}>
                <Tab
                  classes={{ wrapper: classes.tabLabel }}
                  label={this.state.reportTitle + " " + t("REPORT")}
                />
                <Tab
                  classes={{ wrapper: classes.tabLabel }}
                  label={
                    t("MONTHLY") +
                    " " +
                    this.state.reportTitle +
                    " " +
                    t("REPORT")
                  }
                />
              </Tabs>
            </AppBar>
          )}

          {this.state.reportName === "getItemsShippedToCustomer" && (
            <AppBar
              position="static"
              color="transparent"
              style={
                this.props.screen && this.props.screen === "dashboard"
                  ? { boxShadow: "none" }
                  : {}
              }
            >
              <Tabs value={this.state.tabValue} onChange={this.changeTab}>
                <Tab
                  classes={{ wrapper: classes.tabLabel }}
                  label={this.state.reportTitle + " " + t("REPORT")}
                />
                {/* <Tab classes={{ wrapper: classes.tabLabel }} label={t('DOWNLOAD') + ' ' + this.state.reportTitle + ' ' + t('REPORT')} /> */}
                <Tab
                  classes={{ wrapper: classes.tabLabel }}
                  label={
                    t("DOWNLOAD") + " " + t("REPORT") + " " + t("BY_CUSTOMER")
                  }
                />
              </Tabs>
            </AppBar>
          )}
          {this.state.reportName === "getItemsShippedToCustomer" &&
          this.state.tabValue === 1 ? (
            <>
              <Paper
                className={
                  "tablePaper " +
                  (this.props.screen && this.props.screen === "dashboard"
                    ? "noBoxShadow"
                    : "")
                }
              >
                <div className={reportClasses.searchOuterDivFilter}>
                  <div style={{ marginTop: "25px" }}>
                    <BanSelect
                      onSelect={this.onBanSelect}
                      selected={this.state.defaultSelected}
                      defaultValue={this.state.defaultSelected}
                      customers={this.state.customersList}
                    />
                  </div>
                  <div style={{ marginTop: "25px" }}>
                    <TextField
                      name={"startDate"}
                      value={this.state.startDate}
                      placeholder={t("START_DATE")}
                      label={t("START_DATE")}
                      variant={"outlined"}
                      id="date"
                      // type="date"
                      type={
                        this.state.reportName === "getItemsShippedToCustomer"
                          ? "datetime-local"
                          : "date"
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        max: this.state.todayTime,
                      }}
                      // className={classes.inputClass}

                      onChange={(e) => {
                        this.onChangeDateFilter(e);
                      }}
                      onKeyDown={(e) => {
                        this.onSearchDateFilterKeyDown(e);
                      }}
                    />
                  </div>
                  <div style={{ marginTop: "25px" }}>
                    <TextField
                      name={"endDate"}
                      value={this.state.endDate}
                      placeholder={t("END_DATE")}
                      label={t("END_DATE")}
                      variant={"outlined"}
                      id="date"
                      // type="date"
                      type={
                        this.state.reportName === "getItemsShippedToCustomer"
                          ? "datetime-local"
                          : "date"
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        max: this.state.todayTime,
                        min: this.state.startDate,
                      }}
                      // className={classes.inputClass}

                      onChange={(e) => {
                        this.onChangeDateFilter(e);
                      }}
                      onKeyDown={(e) => {
                        this.onSearchDateFilterKeyDown(e);
                      }}
                    />
                  </div>
                  <div>
                    <div className={reportClasses.searchOrderLabelOuter}>
                      <div className={reportClasses.searchOrderLabelInner}>
                        <Button
                          onClick={this.createDownloadFile}
                          style={{ marginTop: "15px" }}
                        >
                          {t("SEARCH")}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ clear: "both" }}></div>
                <div>
                  <br />
                  {this.state.downloadReady && (
                    <>
                      {t("YOUR_FILE_IS_READY_PLEASE_CLICK_ON_DOWNLOAD")} &nbsp;
                      {/* <label onClick={() => this.downExcelReport(this.state.searchedExcelData)}
                                                style={{ color: this.props.tenantData.color ? this.props.tenantData.color : '#003161', cursor: 'pointer' }}>
                                                {t('DOWNLOAD')}
                                            </label> */}
                      <Button
                        onClick={() =>
                          this.downExcelReport(this.state.searchedExcelData)
                        }
                      >
                        {t("DOWNLOAD")}
                      </Button>
                    </>
                  )}
                </div>
              </Paper>
            </>
          ) : (
            <Paper
              className={
                "tablePaper " +
                (this.props.screen && this.props.screen === "dashboard"
                  ? "noBoxShadow"
                  : "")
              }
            >
              <TabPanel
                value={this.state.tabValue}
                index={0}
                className={"tableTabpanelContent"}
              >
                {this.state.searchParameters.length > 0 && (
                  <div>
                    {this.state.searchParameters.length > 5 ? (
                      <>
                        <div
                          className={classes.searchOuterDiv}
                          style={{ justifyContent: "flex-start" }}
                        >
                          {this.state.searchParameters.map((input, index) =>
                            input.name === "customerName" &&
                            (this.props.loggedInUserType ===
                              "ECOMMERCE_CUSTOMER" ||
                              this.props.loggedInUserType === "ECOMMERCE_ADMIN")
                              ? ""
                              : index < 6 && (
                                  <div
                                    className={classes.searchInputDiv}
                                    key={index}
                                  >
                                    {(input.name === "statusId" ||
                                      input.name === "receiptType") &&
                                    this.state.reportName ===
                                      "getInventoryReceiptReport" ? (
                                      <>
                                        {input.name === "statusId" && (
                                          <FormControl
                                            variant="outlined"
                                            size={"small"}
                                          >
                                            <InputLabel id="statusId-label">
                                              {input.description}
                                            </InputLabel>
                                            <Select
                                              native
                                              labelId="statusId-label"
                                              label={input.description}
                                              value={input.value}
                                              onChange={(e) => {
                                                this.onChange(e);
                                              }}
                                              onKeyDown={(e) => {
                                                this.onSearchKeyDown(e);
                                              }}
                                              inputProps={{
                                                name: input.name,
                                                id: "statusId",
                                              }}
                                            >
                                              <option value=""></option>
                                              <option value={"INV_AVAILABLE"}>
                                                {t("AVAILABLE")}
                                              </option>
                                              <option value={"INV_PROMISED"}>
                                                {t("PROMISED")}
                                              </option>
                                              <option value={"INV_DELIVERED"}>
                                                {t("DELIVERED")}
                                              </option>
                                            </Select>
                                          </FormControl>
                                        )}
                                        {input.name === "receiptType" && (
                                          <FormControl
                                            variant="outlined"
                                            size={"small"}
                                          >
                                            <InputLabel id="receiptType-label">
                                              {input.description}
                                            </InputLabel>
                                            <Select
                                              native
                                              labelId="receiptType-label"
                                              label={input.description}
                                              value={input.value}
                                              onChange={(e) => {
                                                this.onChange(e);
                                              }}
                                              onKeyDown={(e) => {
                                                this.onSearchKeyDown(e);
                                              }}
                                              inputProps={{
                                                name: input.name,
                                                id: "receiptType",
                                              }}
                                            >
                                              <option value=""></option>
                                              <option value={"byProduct"}>
                                                {t("BY_PRODUCT")}
                                              </option>
                                              <option value={"byOrder"}>
                                                {t("BY_PURCHASE_ORDER")}
                                              </option>
                                              <option value={"byReturn"}>
                                                {t("BY_RETURN")}
                                              </option>
                                            </Select>
                                          </FormControl>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {this.isDateInput(input.description) ? (
                                          <TextField
                                            name={input.name}
                                            value={input.value}
                                            placeholder={input.description}
                                            label={input.description}
                                            variant={"outlined"}
                                            id="date"
                                            // type="date"
                                            type={
                                              this.state.reportName ===
                                              "getItemsShippedToCustomer"
                                                ? "datetime-local"
                                                : "date"
                                            }
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            className={classes.inputClass}
                                            onChange={(e) => {
                                              this.onChange(e);
                                            }}
                                            onKeyDown={(e) => {
                                              this.onSearchKeyDown(e);
                                            }}
                                          />
                                        ) : (
                                          <Input
                                            placeholder={input.description}
                                            value={input.value}
                                            name={input.name}
                                            type={this.getInputType(input.type)}
                                            size={"small"}
                                            variant={"outlined"}
                                            className={classes.inputClass}
                                            onChange={(e) => {
                                              this.onChange(e);
                                            }}
                                            divClass={classes.inputClass}
                                            onKeyDown={(e) => {
                                              this.onSearchKeyDown(e);
                                            }}
                                          />
                                        )}
                                      </>
                                    )}
                                  </div>
                                ),
                          )}
                        </div>
                        <div
                          style={{
                            display: "block",
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <div
                            className={classes.searchOuterDiv}
                            style={{ justifyContent: "flex-start" }}
                          >
                            {this.state.searchParameters.map((input, index) =>
                              input.name === "customerName" &&
                              (this.props.loggedInUserType ===
                                "ECOMMERCE_CUSTOMER" ||
                                this.props.loggedInUserType ===
                                  "ECOMMERCE_ADMIN")
                                ? ""
                                : index > 5 && (
                                    <div
                                      className={classes.searchInputDiv}
                                      key={index}
                                    >
                                      {(input.name === "statusId" ||
                                        input.name === "receiptType") &&
                                      this.state.reportName ===
                                        "getInventoryReceiptReport" ? (
                                        <>
                                          {input.name === "statusId" && (
                                            <FormControl
                                              variant="outlined"
                                              size={"small"}
                                            >
                                              <InputLabel id="statusId-label">
                                                {input.description}
                                              </InputLabel>
                                              <Select
                                                native
                                                labelId="statusId-label"
                                                label={input.description}
                                                value={input.value}
                                                onChange={(e) => {
                                                  this.onChange(e);
                                                }}
                                                onKeyDown={(e) => {
                                                  this.onSearchKeyDown(e);
                                                }}
                                                inputProps={{
                                                  name: input.name,
                                                  id: "statusId",
                                                }}
                                              >
                                                <option value=""></option>
                                                <option value={"INV_AVAILABLE"}>
                                                  {t("AVAILABLE")}
                                                </option>
                                                <option value={"INV_PROMISED"}>
                                                  {t("PROMISED")}
                                                </option>
                                                <option value={"INV_DELIVERED"}>
                                                  {t("DELIVERED")}
                                                </option>
                                              </Select>
                                            </FormControl>
                                          )}
                                          {input.name === "receiptType" && (
                                            <FormControl
                                              variant="outlined"
                                              size={"small"}
                                            >
                                              <InputLabel id="receiptType-label">
                                                {input.description}
                                              </InputLabel>
                                              <Select
                                                native
                                                value={input.value}
                                                label={input.description}
                                                labelId="receiptType-label"
                                                onChange={(e) => {
                                                  this.onChange(e);
                                                }}
                                                onKeyDown={(e) => {
                                                  this.onSearchKeyDown(e);
                                                }}
                                                inputProps={{
                                                  name: input.name,
                                                  id: "receiptType",
                                                }}
                                              >
                                                <option value=""></option>
                                                <option value={"byProduct"}>
                                                  {t("BY_PRODUCT")}
                                                </option>
                                                <option value={"byOrder"}>
                                                  {t("BY_PURCHASE_ORDER")}
                                                </option>
                                                <option value={"byReturn"}>
                                                  {t("BY_RETURN")}
                                                </option>
                                              </Select>
                                            </FormControl>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {this.isDateInput(
                                            input.description,
                                          ) ? (
                                            <TextField
                                              name={input.name}
                                              value={input.value}
                                              placeholder={input.description}
                                              label={input.description}
                                              variant={"outlined"}
                                              id="date"
                                              // type="date"
                                              type={
                                                this.state.reportName ===
                                                "getItemsShippedToCustomer"
                                                  ? "datetime-local"
                                                  : "date"
                                              }
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              className={classes.inputClass}
                                              onChange={(e) => {
                                                this.onChange(e);
                                              }}
                                              onKeyDown={(e) => {
                                                this.onSearchKeyDown(e);
                                              }}
                                            />
                                          ) : (
                                            <Input
                                              placeholder={input.description}
                                              value={input.value}
                                              name={input.name}
                                              type={this.getInputType(
                                                input.type,
                                              )}
                                              size={"small"}
                                              variant={"outlined"}
                                              className={classes.inputClass}
                                              onChange={(e) => {
                                                this.onChange(e);
                                              }}
                                              divClass={classes.inputClass}
                                              onKeyDown={(e) => {
                                                this.onSearchKeyDown(e);
                                              }}
                                            />
                                          )}
                                        </>
                                      )}
                                    </div>
                                  ),
                            )}

                            {this.state.customSearchParameters.map(
                              (input, index) =>
                                this.props.loggedInUserType ===
                                  "ECOMMERCE_CUSTOMER" ||
                                this.props.loggedInUserType ===
                                  "ECOMMERCE_ADMIN" ? (
                                  ""
                                ) : (
                                  <>
                                    <div
                                      className={classes.searchInputDiv}
                                      key={index}
                                    >
                                      {input.type === "List" ? (
                                        <>
                                          <FormControl
                                            variant="outlined"
                                            size={"small"}
                                          >
                                            <InputLabel id="statusId-label">
                                              {input.description}
                                            </InputLabel>
                                            <Select
                                              native
                                              labelId="statusId-label"
                                              value={input.value}
                                              label={input.description}
                                              onChange={(e) => {
                                                this.onChangeCustomFilters(e);
                                              }}
                                              onKeyDown={(e) => {
                                                this.onSearchKeyDown(e);
                                              }}
                                              inputProps={{
                                                name: input.name,
                                                id: "statusId",
                                              }}
                                            >
                                              {/* <option value=""></option> */}
                                              {input.options.map(
                                                (option, oindex) => (
                                                  <option
                                                    key={oindex}
                                                    value={option.id}
                                                  >
                                                    {option.name}
                                                  </option>
                                                ),
                                              )}
                                            </Select>
                                          </FormControl>
                                        </>
                                      ) : (
                                        <>
                                          {this.isDateInput(
                                            input.description,
                                          ) ? (
                                            <TextField
                                              name={input.name}
                                              value={input.value}
                                              placeholder={input.description}
                                              label={input.description}
                                              variant={"outlined"}
                                              id="date"
                                              // type="date"
                                              type={
                                                this.state.reportName ===
                                                "getItemsShippedToCustomer"
                                                  ? "datetime-local"
                                                  : "date"
                                              }
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              className={classes.inputClass}
                                              onChange={(e) => {
                                                this.onChangeCustomFilters(e);
                                              }}
                                              onKeyDown={(e) => {
                                                this.onSearchKeyDown(e);
                                              }}
                                            />
                                          ) : (
                                            <Input
                                              placeholder={input.description}
                                              value={input.value}
                                              name={input.name}
                                              type={this.getInputType(
                                                input.type,
                                              )}
                                              size={"small"}
                                              variant={"outlined"}
                                              className={classes.inputClass}
                                              onChange={(e) => {
                                                this.onChangeCustomFilters(e);
                                              }}
                                              divClass={classes.inputClass}
                                              onKeyDown={(e) => {
                                                this.onSearchKeyDown(e);
                                              }}
                                            />
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </>
                                ),
                            )}

                            <div
                              className={classes.searchOrderLabelInner}
                              style={{ display: "inline-flex" }}
                            >
                              <Tooltip title={t("SEARCH")}>
                                <IconButton
                                  className="iconButtonSecondary"
                                  onClick={this.filterReportTable}
                                >
                                  <SearchIcon />
                                </IconButton>
                              </Tooltip>{" "}
                              &nbsp;
                              <Tooltip title={t("CLEAR")}>
                                <IconButton
                                  className="iconButtonSecondary"
                                  onClick={this.clearReportTableSearch}
                                >
                                  <ClearIcon />
                                </IconButton>
                              </Tooltip>{" "}
                              &nbsp;
                              {/* use CSV for this report */}
                              {/* {(this.state.reportName === 'getInventoryReceiptReport') &&
                                                                <Tooltip title={t('DOWNLOAD')}>
                                                                    <IconButton className='downloadCsvButton'>
                                                                        <CSVLink data={this.state.csvData} filename={`${this.state.reportName === 'getInventoryReceiptReport' ? 'InventoryReceiptReport' : 'ShippedItemsToCustomers'}.csv`} target="_blank">
                                                                            <DownloadIcon />
                                                                        </CSVLink>
                                                                    </IconButton>
                                                                </Tooltip>
                                                            } */}
                              {/* use excel for this report */}
                              {(this.state.reportName ===
                                "getItemsShippedToCustomer" ||
                                this.state.reportName ===
                                  "getInventoryReceiptReport") && (
                                <Tooltip
                                  title={t("DOWNLOAD")}
                                  onClick={() => this.downloadShippingReport()}
                                >
                                  <IconButton
                                    // className='downloadCsvButton'
                                    className="iconButtonSecondary"
                                  >
                                    <DownloadIconNew />
                                  </IconButton>
                                </Tooltip>
                              )}
                              {this.state.isDownloadableReport &&
                                this.state.totalCount > 0 && (
                                  <Tooltip title={t("DOWNLOAD")}>
                                    <Button
                                      onClick={() =>
                                        this.downExcelReport(
                                          this.state.excelData,
                                        )
                                      }
                                    >
                                      {t("DOWNLOAD")}
                                    </Button>
                                  </Tooltip>
                                )}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className={classes.searchOuterDiv}>
                          {this.state.searchParameters.map((input, index) =>
                            input.name === "customerName" &&
                            (this.props.loggedInUserType ===
                              "ECOMMERCE_CUSTOMER" ||
                              this.props.loggedInUserType ===
                                "ECOMMERCE_ADMIN") ? (
                              ""
                            ) : (
                              <>
                                <div
                                  className={classes.searchInputDiv}
                                  key={index}
                                >
                                  {input.name === "statusId" &&
                                  this.state.reportName ===
                                    "getInventoryReceiptReport" ? (
                                    <>
                                      <FormControl
                                        variant="outlined"
                                        size={"small"}
                                      >
                                        <InputLabel id="statusId-label">
                                          {input.description}
                                        </InputLabel>
                                        <Select
                                          native
                                          value={input.value}
                                          labelId="statusId-label"
                                          label={input.description}
                                          onChange={(e) => {
                                            this.onChange(e);
                                          }}
                                          onKeyDown={(e) => {
                                            this.onSearchKeyDown(e);
                                          }}
                                          inputProps={{
                                            name: input.name,
                                            id: "statusId",
                                          }}
                                        >
                                          <option value=""></option>
                                          <option value={"INV_AVAILABLE"}>
                                            {t("AVAILABLE")}
                                          </option>
                                          <option value={"INV_PROMISED"}>
                                            {t("PROMISED")}
                                          </option>
                                          <option value={"INV_DELIVERED"}>
                                            {t("DELIVERED")}
                                          </option>
                                        </Select>
                                      </FormControl>
                                    </>
                                  ) : (
                                    <>
                                      {this.isDateInput(input.description) ? (
                                        <TextField
                                          name={input.name}
                                          value={input.value}
                                          placeholder={input.description}
                                          label={input.description}
                                          variant={"outlined"}
                                          id="date"
                                          // type="date"
                                          type={
                                            this.state.reportName ===
                                            "getItemsShippedToCustomer"
                                              ? "datetime-local"
                                              : "date"
                                          }
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          className={classes.inputClass}
                                          onChange={(e) => {
                                            this.onChange(e);
                                          }}
                                          onKeyDown={(e) => {
                                            this.onSearchKeyDown(e);
                                          }}
                                        />
                                      ) : (
                                        <Input
                                          placeholder={input.description}
                                          value={input.value}
                                          name={input.name}
                                          type={this.getInputType(input.type)}
                                          size={"small"}
                                          variant={"outlined"}
                                          className={classes.inputClass}
                                          onChange={(e) => {
                                            this.onChange(e);
                                          }}
                                          divClass={classes.inputClass}
                                          onKeyDown={(e) => {
                                            this.onSearchKeyDown(e);
                                          }}
                                        />
                                      )}
                                    </>
                                  )}
                                </div>
                              </>
                            ),
                          )}
                          {this.state.customSearchParameters.map(
                            (input, index) =>
                              this.props.loggedInUserType ===
                                "ECOMMERCE_CUSTOMER" ||
                              this.props.loggedInUserType ===
                                "ECOMMERCE_ADMIN" ? (
                                ""
                              ) : (
                                <>
                                  <div
                                    className={classes.searchInputDiv}
                                    key={index}
                                  >
                                    {input.type === "List" ? (
                                      <>
                                        <FormControl
                                          variant="outlined"
                                          size={"small"}
                                        >
                                          <InputLabel id="statusId-label">
                                            {input.description}
                                          </InputLabel>
                                          <Select
                                            native
                                            value={input.value}
                                            labelId="statusId-label"
                                            label={input.description}
                                            onChange={(e) => {
                                              this.onChangeCustomFilters(e);
                                            }}
                                            onKeyDown={(e) => {
                                              this.onSearchKeyDown(e);
                                            }}
                                            inputProps={{
                                              name: input.name,
                                              id: "statusId",
                                            }}
                                          >
                                            {/* <option value=""></option> */}
                                            {input.options.map(
                                              (option, oindex) => (
                                                <option
                                                  key={oindex}
                                                  value={option.id}
                                                >
                                                  {option.name}
                                                </option>
                                              ),
                                            )}
                                          </Select>
                                        </FormControl>
                                      </>
                                    ) : (
                                      <>
                                        {this.isDateInput(input.description) ? (
                                          <TextField
                                            name={input.name}
                                            value={input.value}
                                            placeholder={input.description}
                                            label={input.description}
                                            variant={"outlined"}
                                            id="date"
                                            // type="date"
                                            type={
                                              this.state.reportName ===
                                              "getItemsShippedToCustomer"
                                                ? "datetime-local"
                                                : "date"
                                            }
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            className={classes.inputClass}
                                            onChange={(e) => {
                                              this.onChangeCustomFilters(e);
                                            }}
                                            onKeyDown={(e) => {
                                              this.onSearchKeyDown(e);
                                            }}
                                          />
                                        ) : (
                                          <Input
                                            placeholder={input.description}
                                            value={input.value}
                                            name={input.name}
                                            type={this.getInputType(input.type)}
                                            size={"small"}
                                            variant={"outlined"}
                                            className={classes.inputClass}
                                            onChange={(e) => {
                                              this.onChangeCustomFilters(e);
                                            }}
                                            divClass={classes.inputClass}
                                            onKeyDown={(e) => {
                                              this.onSearchKeyDown(e);
                                            }}
                                          />
                                        )}
                                      </>
                                    )}
                                  </div>
                                </>
                              ),
                          )}
                          <div
                            className={classes.searchOrderLabelInner}
                            style={{ display: "inline-flex" }}
                          >
                            <Tooltip title={t("SEARCH")}>
                              <IconButton
                                className="iconButtonSecondary"
                                onClick={this.filterReportTable}
                              >
                                <SearchIcon />
                              </IconButton>
                            </Tooltip>{" "}
                            &nbsp;
                            <Tooltip title={t("CLEAR")}>
                              <IconButton
                                className="iconButtonSecondary"
                                onClick={this.clearReportTableSearch}
                              >
                                <ClearIcon />
                              </IconButton>
                            </Tooltip>{" "}
                            &nbsp;
                            {(this.state.reportName ===
                              "getInventoryReceiptReport" ||
                              this.state.reportName ===
                                "getItemsShippedToCustomer") && (
                              <Tooltip title={t("DOWNLOAD")}>
                                <IconButton
                                  // className='downloadCsvButton'
                                  className="iconButtonSecondary"
                                >
                                  <CSVLink
                                    data={this.state.csvData}
                                    filename={`${this.state.reportName === "getInventoryReceiptReport" ? "InventoryReceiptReport" : "ShippedItemsToCustomers"}.csv`}
                                    target="_blank"
                                  >
                                    <DownloadIconNew />
                                  </CSVLink>
                                </IconButton>
                              </Tooltip>
                            )}
                            {this.state.isDownloadableReport &&
                              this.state.totalCount > 0 && (
                                <Tooltip title={t("DOWNLOAD")}>
                                  <IconButton
                                    // className='downloadExcelReportButton'
                                    className="iconButtonSecondary"
                                    onClick={() =>
                                      this.downExcelReport(this.state.excelData)
                                    }
                                  >
                                    <DownloadIconNew />
                                  </IconButton>
                                </Tooltip>
                              )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </TabPanel>
              <TabPanel
                value={this.state.tabValue}
                index={1}
                className={"tableTabpanelContent"}
              >
                {this.state.searchParameters.length > 0 && (
                  <div>
                    {this.state.searchParameters.length > 0 && (
                      <>
                        <div className={classes.searchOuterDiv}>
                          {this.state.searchParameters.map((input, index) =>
                            input.name === "customerName" &&
                            (this.props.loggedInUserType ===
                              "ECOMMERCE_CUSTOMER" ||
                              this.props.loggedInUserType ===
                                "ECOMMERCE_ADMIN") ? (
                              ""
                            ) : (
                              <>
                                {this.isDateInput(input.description) ? (
                                  ""
                                ) : (
                                  <div
                                    className={classes.searchInputDiv}
                                    key={index}
                                  >
                                    {input.name === "statusId" &&
                                    this.state.reportName ===
                                      "getInventoryReceiptReport" ? (
                                      <>
                                        <FormControl
                                          variant="outlined"
                                          size={"small"}
                                        >
                                          <InputLabel id="statusId-label">
                                            {input.description}
                                          </InputLabel>
                                          <Select
                                            native
                                            value={input.value}
                                            labelId="statusId-label"
                                            label={input.description}
                                            onChange={(e) => {
                                              this.onChange(e);
                                            }}
                                            onKeyDown={(e) => {
                                              this.onSearchKeyDown(e);
                                            }}
                                            inputProps={{
                                              name: input.name,
                                              id: "statusId",
                                            }}
                                          >
                                            <option value=""></option>
                                            <option value={"INV_AVAILABLE"}>
                                              {t("AVAILABLE")}
                                            </option>
                                            <option value={"INV_PROMISED"}>
                                              {t("PROMISED")}
                                            </option>
                                            <option value={"INV_DELIVERED"}>
                                              {t("DELIVERED")}
                                            </option>
                                          </Select>
                                        </FormControl>
                                      </>
                                    ) : (
                                      <>
                                        {this.isDateInput(input.description) ? (
                                          <>
                                            {/* <TextField
                                                                                    name={input.name}
                                                                                    value={input.value}
                                                                                    placeholder={input.description}
                                                                                    label={input.description}

                                                                                    variant={'outlined'}
                                                                                    id="date"
                                                                                    type={this.state.reportName === 'getItemsShippedToCustomer' ? 'datetime-local' : 'date'}
                                                                                    InputLabelProps={{
                                                                                        shrink: true,
                                                                                    }}
                                                                                    className={classes.inputClass}

                                                                                    onChange={(e) => { this.onChange(e) }}
                                                                                    onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                                                                                /> */}
                                          </>
                                        ) : (
                                          <Input
                                            placeholder={input.description}
                                            value={input.value}
                                            name={input.name}
                                            type={this.getInputType(input.type)}
                                            size={"small"}
                                            variant={"outlined"}
                                            className={classes.inputClass}
                                            onChange={(e) => {
                                              this.onChange(e);
                                            }}
                                            divClass={classes.inputClass}
                                            onKeyDown={(e) => {
                                              this.onSearchKeyDown(e);
                                            }}
                                          />
                                        )}
                                      </>
                                    )}
                                  </div>
                                )}
                              </>
                            ),
                          )}
                          <div className={classes.searchInputDiv}>
                            <FormControl
                              variant="outlined"
                              size={"small"}
                            >
                              <InputLabel id="selectYear-label">
                                {t("SELECT_YEAR")}
                              </InputLabel>
                              <Select
                                native
                                size={"small"}
                                labelId="selectYear-label"
                                label={t("SELECT_YEAR")}
                                variant={"outlined"}
                                name={"selectedYear"}
                                inputProps={{
                                  name: "selectedYear",
                                  id: "outlined-native-selectedYear",
                                }}
                                //value={(a) => a.value}
                                value={this.state.selectedYear}
                                onChange={(e) => {
                                  this.onChangeMonthFilter(e);
                                }}
                                onKeyDown={(e) => {
                                  this.onSearchKeyDown(e);
                                }}
                                selectClass={
                                  orderClasses.inputClass +
                                  " " +
                                  orderClasses.statusSelectBg +
                                  " " +
                                  orderClasses.searchOrderSelect
                                }
                              >
                                {this.state.yearsList.map((a) => (
                                  <option key={a} value={a}>
                                    {a}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                          <div className={classes.searchInputDiv}>
                            <FormControl
                              variant="outlined"
                              size={"small"}
                            >
                              <InputLabel id="selectMonth-label">
                                {t("SELECT_MONTH")}
                              </InputLabel>
                              <Select
                                native
                                size={"small"}
                                labelId="selectMonth-label"
                                label={t("SELECT_MONTH")}
                                variant={"outlined"}
                                name={"selectedMonth"}
                                inputProps={{
                                  name: "selectedMonth",
                                  id: "outlined-native-selectedMonth",
                                }}
                                //value={(a) => a.value}
                                value={this.state.selectedMonth}
                                onChange={(e) => {
                                  this.onChangeMonthFilter(e);
                                }}
                                onKeyDown={(e) => {
                                  this.onSearchKeyDown(e);
                                }}
                                selectClass={
                                  orderClasses.inputClass +
                                  " " +
                                  orderClasses.statusSelectBg +
                                  " " +
                                  orderClasses.searchOrderSelect
                                }
                              >
                                {this.state.monthList.map((a) => (
                                  <option key={a.value} value={a.value}>
                                    {a.name}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                          <div
                            className={classes.searchOrderLabelInner}
                            style={{ display: "inline-flex" }}
                          >
                            <Tooltip title={t("SEARCH")}>
                              <IconButton
                                className="iconButtonSecondary"
                                onClick={this.filterReportTable}
                              >
                                <SearchIcon />
                              </IconButton>
                            </Tooltip>{" "}
                            &nbsp;
                            <Tooltip title={t("CLEAR")}>
                              <IconButton
                                className="iconButtonSecondary"
                                onClick={this.clearReportTableSearch}
                              >
                                <ClearIcon />
                              </IconButton>
                            </Tooltip>{" "}
                            &nbsp;
                            {(this.state.reportName ===
                              "getInventoryReceiptReport" ||
                              this.state.reportName ===
                                "getItemsShippedToCustomer") && (
                              <Tooltip title={t("DOWNLOAD")}>
                                <IconButton
                                  // className='downloadCsvButton'
                                  className="iconButtonSecondary"
                                >
                                  <CSVLink
                                    data={this.state.csvData}
                                    filename={`${this.state.reportName === "getInventoryReceiptReport" ? "InventoryReceiptReport" : "ShippedItemsToCustomers"}.csv`}
                                    target="_blank"
                                  >
                                    <DownloadIconNew />
                                  </CSVLink>
                                </IconButton>
                              </Tooltip>
                            )}
                            {this.state.isDownloadableReport &&
                              this.state.totalCount > 0 && (
                                <Tooltip title={t("DOWNLOAD")}>
                                  <Button
                                    onClick={() =>
                                      this.downExcelReport(this.state.excelData)
                                    }
                                  >
                                    {t("DOWNLOAD")}
                                  </Button>
                                </Tooltip>
                              )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </TabPanel>
              {this.state.nestedReport ? (
                this.state.nestedReportData.length > 0 &&
                this.state.nestedReportData.map((report, reportIndex) => (
                  <React.Fragment key={reportIndex}>
                    {report.length > 0 && (
                      <TableContainer
                        style={{ marginTop: reportIndex === 0 ? 0 : 50 }}
                      >
                        <Table
                          className={classes.table}
                          aria-label="simple table"
                        >
                          <TableHead>
                            <TableRow>
                              {Object.keys(report[0]).map((keyName, i) => (
                                <TableCell key={i}>
                                  <b>
                                    {this.camelCasetoSentenceString(keyName)}
                                  </b>
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {/* Show Report rows */}
                            {report.map((row, index) => (
                              <TableRow
                                key={index}
                                // hover
                              >
                                {Object.keys(row).map((keyName, i) => (
                                  <TableCell key={i}>
                                    {keyName.toLowerCase().includes("date")
                                      ? this.validateAndConvertTimeStamp(
                                          row[keyName],
                                        )
                                      : row[keyName]}
                                  </TableCell>
                                ))}
                              </TableRow>
                            ))}
                          </TableBody>
                          {this.getNestedReportFooter(reportIndex) && (
                            <TableFooter
                              className={classes.nestedReportTableFooter}
                            >
                              {this.getNestedReportFooter(reportIndex).map(
                                (row, index) => (
                                  <TableRow key={index}>
                                    <TableCell
                                      colSpan={Object.keys(report[0]).length}
                                    >
                                      <b>
                                        {this.camelCasetoSentenceString(
                                          row.title,
                                        )}
                                        : {row.value}
                                      </b>
                                    </TableCell>
                                  </TableRow>
                                ),
                              )}
                            </TableFooter>
                          )}
                        </Table>
                      </TableContainer>
                    )}
                    {report.length === 0 && (
                      <TableContainer
                        style={{ marginTop: reportIndex === 0 ? 0 : 50 }}
                      >
                        <Table
                          className={classes.table}
                          aria-label="simple table"
                        >
                          <TableBody>
                            <TableRow>
                              <TableCell align="center">
                                {t("NO_DATA_FOUND")}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </React.Fragment>
                ))
              ) : this.state.reportData.length > 0 ? (
                <TableContainer>
                  <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        {Object.keys(this.state.reportData[0]).map(
                          (keyName, i) => (
                            <TableCell key={i}>
                              <b>{this.camelCasetoSentenceString(keyName)}</b>
                            </TableCell>
                          ),
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* Show Report rows */}
                      {this.state.reportData.map((row, index) => (
                        <TableRow
                          key={index}
                          // hover
                        >
                          {Object.keys(row).map((keyName, i) => (
                            <TableCell key={i}>
                              {keyName.toLowerCase().includes("date") ? (
                                this.validateAndConvertTimeStamp(row[keyName])
                              ) : Object.keys(row).length > 4 ? (
                                <p
                                  style={{
                                    maxWidth: "300px",
                                    whiteSpace: "break-spaces",
                                    wordWrap: "break-word",
                                    margin: "0",
                                  }}
                                >
                                  {row[keyName]}
                                </p>
                              ) : (
                                <p style={{ margin: "0" }}>{row[keyName]}</p>
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <TableContainer>
                  <Table className={classes.table} aria-label="simple table">
                    <TableBody>
                      <TableRow>
                        <TableCell align="center">
                          {t("NO_DATA_FOUND")}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              {this.state.showPagination && this.state.totalCount > 0 && (
                <div
                  className="global-custom-pagination"
                  style={{ background: "rgba(196, 196, 196, 0.2)" }}
                >
                  <label style={{ float: "left", padding: "5px" }}>
                    {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalCount)}
                  </label>
                  <label>
                    {t("ROWS_PER_PAGE")}
                    <Select
                      value={this.state.rowsPerPage}
                      onChange={this.handleChangeRowsPerPage}
                    >
                      {/* <MenuItem value={5}>5</MenuItem> */}
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </label>
                  {/* Pagination component */}
                  <Pagination
                    count={Math.ceil(
                      this.state.totalCount / this.state.rowsPerPage,
                    )}
                    onChange={this.changePage}
                    page={this.state.page}
                    showFirstButton
                    showLastButton
                  />
                </div>
              )}
            </Paper>
          )}

          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    loggedInUserType: state.auth.userLoginType,
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    loggedInUserType: state.auth.userLoginType,
    ecommerceCustData: state.auth.ecommerceCustData,
    tenantData: state.auth.tenantData,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(GenericReports)));
